import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { shipmentsAPI } from "../../api/shipments/shipments";

const initialState = {
    unauthorized: false,
    shipment: null,
    shipmentID: null,
    isEditingMode: false,
    collectingData: false,
    deliveryPriceHasChanged: false,
    accordions: {
        additionalOpened: false,
        receiverOpened: false,
    },
    statuses: {
        uploading: null,
        updating: null,
        deleting: null,
        uploadingDeliveryPrice: null,
        uploadingTotalPrices: null,
        sendEtgbBillDocument: null,
        sendingToAkad: null,
        settingInvoiceType: null,
        sendOwnInvoice: null,
        sendC2CFile: null,
    },
    errors: {
        uploading: null,
        updating: null,
        deleting: null,
        uploadingDeliveryPrice: null,
        uploadingTotalPrices: null,
        sendEtgbBillDocument: null,
        sendingToAkad: null,
        settingInvoiceType: null,
        sendOwnInvoice: null,
        sendC2CFile: null,
    },
    shipmentDeletingPopup: {
        opened: false,
        shipmentID: null,
    },
    sendingToAkadPopupData: {
        opened: false,
        shipmentID: null,
    },
};

export const uploadShipment = createAsyncThunk(
    "shipment/uploadShipmnent",
    async ({ shipmentID }, { rejectWithValue, dispatch }) => {
        if (!shipmentID) {
            return rejectWithValue({ err: "shipment id is required" });
        }
        let resp = await shipmentsAPI.uploadOneShipment(shipmentID);
        if (resp.ok) {
            return { shipment: resp.shipment };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const uploadShipmentDeliveryPrices = createAsyncThunk(
    "shipment/uploadShipmentDeliveryPrice",
    async ({ shipmentID }, { rejectWithValue, dispatch }) => {
        let resp = await shipmentsAPI.uploadShipmentDeliveryPrices(shipmentID);
        if (resp.ok) {
            return { prices: resp.prices };
        }

        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }

        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }

        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const uploadShipmentTotalPrices = createAsyncThunk(
    "shipment/uploadShipmentTotalPrices",
    async ({ shipmentID }, { rejectWithValue, dispatch }) => {
        let resp = await shipmentsAPI.uploadShipmentTotalPrices(shipmentID);
        if (resp.ok) {
            return { prices: resp.prices };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const updateShipment = createAsyncThunk(
    "shipment/updateShipment",
    async ({ data, shipmentID }, { rejectWithValue, dispatch }) => {
        const preparedData = {
            "getting-package-type": data["getting-package-type"],
            "delivery-speed": data["delivery-speed"],
            "package-type": data["package-type"],
            "payment-type": data["payment-type"],
            "B2B-order-type": data["B2B-order-type"],
            "B2B-order-number": +data["B2B-order-number"],
            "sender-city-code": data["sender-city-code"],
            "sender-town-id": +data["sender-town-id"],
            "sender-district-id": +data["sender-district-id"],
            "sender-address": data["sender-address"],
            "declared-price": +data["declared-price"],
            "declared-price-currency": data["declared-price-currency"],
            "receiver-company": data["receiver-company"],
            "receiver-postal-index": data["receiver-postal-index"],
            "receiver-name": data["receiver-name"],
            "receiver-address": data["receiver-address"],
            "receiver-phone-number": data["receiver-phone-number"],
            "receiver-email": data["receiver-email"],
            "receiver-country": data["receiver-country"],
            "receiver-city": data["receiver-city"],
            "receiver-district": data["receiver-district"],
            "receiver-area": data["receiver-area"],
            description: data["receiver-description"],
        };

        let resp = await shipmentsAPI.updateShipment(preparedData, shipmentID);
        if (resp.ok) {
            return { shipment: resp.shipment };
        }

        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }

        if (resp.validationErrors) {
            return rejectWithValue({
                validationErrors: resp.validationErrors,
            });
        }

        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }

        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const deleteShipment = createAsyncThunk(
    "shipment/deleteShipment",
    async ({ shipmentID }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.deleteShipment(shipmentID);
        if (resp.ok) {
            return { shipment: resp.shipment };
        }
        //continue
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const sendETGBBillDocument = createAsyncThunk(
    "shipment/sendEtgbBillDocument",
    async ({ shipmentID, file }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.sendEtgbBillDocument(shipmentID, file);
        if (resp.ok) {
            return { fileName: resp.fileName };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);
export const sendOwnInvoice = createAsyncThunk(
    "shipment/sendOwnInvoice",
    async ({ shipmentID, file }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.sendOwnInvoice(shipmentID, file);
        if (resp.ok) {
            return { fileName: resp.fileName };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);
export const sendC2CFile = createAsyncThunk(
    "shipment/sendC2CFile",
    async ({ shipmentID, file }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.sendC2CFile(shipmentID, file);
        if (resp.ok) {
            return { fileName: resp.fileName };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const setInvoiceType = createAsyncThunk(
    "shipment/setInvoiceType",
    async ({ shipmentID, invoiceType }, { rejectWithValue }) => {
        let resp = await shipmentsAPI.setInvoiceType(shipmentID, invoiceType);
        if (resp.ok) {
            return { invoiceType };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const sendShipmentToAkad = createAsyncThunk(
    "shipments/sendShipmentToAkad",
    async ({ shipmentID }, { rejectWithValue, dispatch }) => {
        let resp = await shipmentsAPI.sendShipmnentToAkad(shipmentID);
        if (resp.ok) {
            return { shipment: resp.shipment };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);



const checkChangingDeliveryPrices = (state, action) => {
    let { prices } = action.payload;
    if (!state.shipment) {
        return;
    }
    if (
        (typeof state.shipment["delivery-price"] === 'number' &&
        state.shipment["delivery-price"] !== prices["delivery-price"]) ||
        (typeof state.shipment["etgb-price"] === 'number' &&
        state.shipment["etgb-price"] !== prices["etgb-price"]) ||
        (typeof state.shipment["over-200-euro-invoice-price"] === 'number' &&
        state.shipment["over-200-euro-invoice-price"] !==
            prices["over-200-euro-invoice-price"])
    ) {
        state.deliveryPriceHasChanged = true;
    }
}

const shipmentSlice = createSlice({
    name: "shipment",
    initialState: initialState,
    reducers: {
        setShipmentToInitialState(state, action) {
            return initialState;
        },
        removeAllShipmentErrors(state, action) {
            state.errors.uploading = null;
            state.errors.updating = null;
        },
        setCollectingData(state, action) {
            state.collectingData = action.payload.value;
        },
        setIsEditingMode(state, action) {
            state.isEditingMode = action.payload.isEditing ?? false;
        },
        setAccordions(state, action) {
            let accordionState = action.payload;
            if (!accordionState) {
                return;
            }
            state.accordions = accordionState;
        },
        setUnauthorized(state, action) {
            let unauthorized = action.payload.unauthorized;
            if (unauthorized === undefined) {
                return;
            }
            state.unauthorized = !!unauthorized;
        },
        setDeletingStatus(state, action) {
            state.statuses.deleting = action.payload.status ?? null;
        },
        setShipmentUpdatingError(state, action) {
            state.errors.updating = action.payload;
        },
        setShipmnetDeletingError(state, action) {
            state.errors.deleting = action.payload;
        },
        setDeliveryPriceHasChanged(state, action) {
            state.deliveryPriceHasChanged = action.payload;
        },
        openShipmentDeletingPopup(state, action) {
            state.shipmentDeletingPopup.opened = true;
            state.shipmentDeletingPopup.shipmentID =
                action.payload.shipmentID ?? null;
        },
        closeShipmentDeletingPopup(state, action) {
            state.shipmentDeletingPopup.opened = false;
            state.shipmentDeletingPopup.shipmentID = null;
        },

        setSendingToAkadStatus(state, action) {
            state.statuses.sendingToAkad = action.payload ?? null;
        },
        setSendingToAkadError(state, action) {
            state.errors.sendingToAkad = action.payload ?? null;
        },
        openSendShipmentToAkadPopup(state, action) {
            if (!action.payload?.shipmentID) {
                return;
            }
            state.sendingToAkadPopupData.opened = true;
            state.sendingToAkadPopupData.shipmentID =
                action.payload.shipmentID ?? null;
        },
        closeSendShipmentToAkadPopup(state, action) {
            state.sendingToAkadPopupData.opened = false;
            state.sendingToAkadPopupData.shipmentID = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(uploadShipment.fulfilled, (state, action) => {
            let { shipment } = action.payload;
            state.shipment = shipment;
            state.errors.uploading = null;
            state.statuses.uploading = "fulfilled";
        });
        builder.addCase(uploadShipment.pending, (state, action) => {
            state.statuses.uploading = "pending";
            state.errors.uploading = null;
        });
        builder.addCase(uploadShipment.rejected, (state, action) => {
            state.statuses.uploading = "rejected";
            const { err } = action.payload;

            if (err === "unauthorized") {
                state.unauthorized = true;
                return;
            }

            if (err) {
                state.errors.uploading = action.payload.err;
            }
        });

        builder.addCase(
            uploadShipmentDeliveryPrices.fulfilled,
            (state, action) => {
                const { prices } = { ...action.payload };
                if (!state.shipment) {
                    return;
                }

                state.errors.uploadingDeliveryPrice = null;
                state.statuses.uploadingDeliveryPrice = "fulfilled";
                if (
                    state.shipment["delivery-price"] ===
                        prices["delivery-price"] &&
                    state.shipment["etgb-price"] === prices["etgb-price"] &&
                    state.shipment["over-200-euro-invoice-price"] ===
                        prices["over-200-euro-invoice-price"]
                ) {
                    return;
                }

                state.deliveryPriceHasChanged = true;
                state.shipment["delivery-price"] = prices["delivery-price"];
                state.shipment["etgb-price"] = prices["etgb-price"];
                state.shipment["over-200-euro-invoice-price"] =
                    prices["over-200-euro-invoice-price"];
            }
        );
        builder.addCase(
            uploadShipmentDeliveryPrices.pending,
            (state, action) => {
                state.statuses.uploadingDeliveryPrice = "pending";
                state.errors.uploadingDeliveryPrice = null;
            }
        );
        builder.addCase(
            uploadShipmentDeliveryPrices.rejected,
            (state, action) => {
                state.statuses.uploadingDeliveryPrice = "rejected";

                if (action.payload.err === "unauthorized") {
                    state.unauthorized = true;
                    return;
                }

                if (action.payload.err) {
                    state.errors.uploadingDeliveryPrice = action.payload.err;
                    return;
                }
                state.errors.uploadingDeliveryPrice = "something_went_wrong";
            }
        );

        builder.addCase(
            uploadShipmentTotalPrices.fulfilled,
            (state, action) => {
                let { prices } = action.payload;
                if (state.shipment) {
                    state.shipment["price-USD"] = prices["price-USD"];
                    state.shipment["price-EUR"] = prices["price-EUR"];
                    state.shipment["price-TRY"] = prices["price-TRY"];
                }
                state.errors.uploadingTotalPrices = null;
                state.statuses.uploadingTotalPrices = "fulfilled";
            }
        );
        builder.addCase(uploadShipmentTotalPrices.pending, (state, action) => {
            state.statuses.uploadingTotalPrices = "pending";
            state.errors.uploadingTotalPrices = null;
        });
        builder.addCase(uploadShipmentTotalPrices.rejected, (state, action) => {
            state.statuses.uploadingTotalPrices = "rejected";

            if (action.payload.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }

            if (action.payload.err) {
                state.errors.uploadingTotalPrices = action.payload.err;
                return;
            }
            state.errors.uploadingTotalPrices = "something_went_wrong";
        });

        builder.addCase(updateShipment.fulfilled, (state, action) => {
            let { shipment } = action.payload;
            checkChangingDeliveryPrices(state, {
                payload: {
                    prices: {
                        "delivery-price": shipment["delivery-price"],
                        "etgb-price": shipment["etgb-price"],
                        "over-200-euro-invoice-price":
                            shipment["over-200-euro-invoice-price"],
                    },
                },
            });

            state.shipment = shipment;

            state.errors.updating = null;
            state.statuses.updating = "fulfilled";
        });
        builder.addCase(updateShipment.pending, (state, action) => {
            state.statuses.updating = "pending";
            state.errors.updating = null;
        });
        builder.addCase(updateShipment.rejected, (state, action) => {
            state.statuses.updating = "rejected";
            if (action.payload.validationErrors) {
                state.errors.updating = "invalid_data";
                return;
            }

            if (action.payload.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }

            if (action.payload.err) {
                state.errors.updating = action.payload.err;
                return;
            }
            state.errors.updating = "something_went_wrong";
        });

        builder.addCase(deleteShipment.fulfilled, (state, action) => {
            state.shipment = null;
            state.errors.deleting = null;
            state.statuses.deleting = "fulfilled";
        });
        builder.addCase(deleteShipment.pending, (state, action) => {
            state.statuses.deleting = "pending";
            state.errors.deleting = null;
        });
        builder.addCase(deleteShipment.rejected, (state, action) => {
            state.statuses.deleting = "rejected";

            if (action.payload?.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }
            if (action.payload?.err) {
                state.errors.deleting = action.payload.err;
                return;
            }
            state.errors.deleting = "something_went_wrong";
        });

        builder.addCase(sendETGBBillDocument.fulfilled, (state, action) => {
            let fileName = action.payload?.fileName;
            if (!fileName) {
                state.errors.sendEtgbBillDocument = "something_went_wrong";
                state.statuses.sendEtgbBillDocument = "rejected";
            }

            state.shipment["etgb-file-name"] = fileName;
            state.errors.sendEtgbBillDocument = null;
            state.statuses.sendEtgbBillDocument = "fulfilled";
        });
        builder.addCase(sendETGBBillDocument.pending, (state, action) => {
            state.statuses.sendEtgbBillDocument = "pending";
            state.errors.sendEtgbBillDocument = null;
        });
        builder.addCase(sendETGBBillDocument.rejected, (state, action) => {
            state.statuses.sendEtgbBillDocument = "rejected";

            if (action.payload?.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }
            if (action.payload?.err) {
                state.errors.sendEtgbBillDocument = action.payload.err;
                return;
            }
            state.errors.sendEtgbBillDocument = "something_went_wrong";
        });

        builder.addCase(sendOwnInvoice.fulfilled, (state, action) => {
            let fileName = action.payload?.fileName;
            if (!fileName) {
                state.errors.sendOwnInvoice = "something_went_wrong";
                state.statuses.sendOwnInvoice = "rejected";
            }

            state.shipment["own-invoice-file-name"] = fileName;
            state.errors.sendOwnInvoice = null;
            state.statuses.sendOwnInvoice = "fulfilled";
        });
        builder.addCase(sendOwnInvoice.pending, (state, action) => {
            state.statuses.sendOwnInvoice = "pending";
            state.errors.sendOwnInvoice = null;
        });
        builder.addCase(sendOwnInvoice.rejected, (state, action) => {
            state.statuses.sendOwnInvoice = "rejected";

            if (action.payload?.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }
            if (action.payload?.err) {
                state.errors.sendOwnInvoice = action.payload.err;
                return;
            }
            state.errors.sendOwnInvoice = "something_went_wrong";
        });

        builder.addCase(sendC2CFile.fulfilled, (state, action) => {
            let fileName = action.payload?.fileName;
            if (!fileName) {
                state.errors.sendC2CFile = "something_went_wrong";
                state.statuses.sendC2CFile = "rejected";
            }

            state.shipment["c2c-file-name"] = fileName;
            state.errors.sendC2CFile = null;
            state.statuses.sendC2CFile = "fulfilled";
        });
        builder.addCase(sendC2CFile.pending, (state, action) => {
            state.statuses.sendC2CFile = "pending";
            state.errors.sendC2CFile = null;
        });
        builder.addCase(sendC2CFile.rejected, (state, action) => {
            state.statuses.sendC2CFile = "rejected";

            if (action.payload?.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }
            if (action.payload?.err) {
                state.errors.sendC2CFile = action.payload.err;
                return;
            }
            state.errors.sendC2CFile = "something_went_wrong";
        });

        builder.addCase(sendShipmentToAkad.fulfilled, (state, action) => {
            let { shipment } = action.payload;
            if (!shipment) {
                state.errors.sendingToAkad = "something_went_wrong";
                state.statuses.sendingToAkad = "rejected";
            }
            state.errors.sendingToAkad = null;
            state.statuses.sendingToAkad = "fulfilled";
            state.shipment = shipment;
        });
        builder.addCase(sendShipmentToAkad.pending, (state, action) => {
            state.errors.sendingToAkad = null;
            state.statuses.sendingToAkad = "pending";
        });
        builder.addCase(sendShipmentToAkad.rejected, (state, action) => {
            state.statuses.sendingToAkad = "rejected";

            if (action.payload?.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }
            if (action.payload?.err) {
                state.errors.sendingToAkad = action.payload.err;
                return;
            }
            state.errors.sendingToAkad = "something_went_wrong";
        });

        builder.addCase(setInvoiceType.fulfilled, (state, action) => {
            const { invoiceType } = action.payload;

            state.shipment["is-pony-express-invoice"] = invoiceType === "pony";

            state.errors.settingInvoiceType = null;
            state.statuses.settingInvoiceType = "fulfilled";
        });
        builder.addCase(setInvoiceType.pending, (state, action) => {
            state.errors.settingInvoiceType = null;
            state.statuses.settingInvoiceType = "pending";
        });
        builder.addCase(setInvoiceType.rejected, (state, action) => {
            state.statuses.settingInvoiceType = "rejected";

            if (action.payload?.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }
            if (action.payload?.err) {
                state.errors.settingInvoiceType = action.payload.err;
                return;
            }
            state.errors.settingInvoiceType = "something_went_wrong";
        });
    },
});

export const selectShipment = (state) => state.shipment.shipment;
export const selectShipmentDeliveryPriceHasChanged = (state) =>
    state.shipment.deliveryPriceHasChanged;
export const selectIsEditingMode = (state) => state.shipment.isEditingMode;
export const selectCollectingData = (state) => state.shipment.collectingData;

//select statuses
export const selectShipmentUploadingStatus = (state) =>
    state.shipment.statuses.uploading;
export const selectShipmentUploadingError = (state) =>
    state.shipment.errors.uploading;

export const selectShipmentUpdatingStatus = (state) =>
    state.shipment.statuses.updating;
export const selectShipmentUpdatingError = (state) =>
    state.shipment.errors.updating;

export const selectShipmentDeletingStatus = (state) =>
    state.shipment.statuses.deleting;
export const selectShipmentDeletingError = (state) =>
    state.shipment.errors.deleting;

export const selectShipmentAccordions = (state) => state.shipment.accordions;
export const selectShipmentUnauthorized = (state) =>
    state.shipment.unauthorized;

export const selectShipmentDeletingPopup = (state) =>
    state.shipment.shipmentDeletingPopup;
export const selectSendShipmentToAkadPopupData = (state) =>
    state.shipment.sendingToAkadPopupData;

export const selectShipmentETGBBillDocumentStatus = (state) =>
    state.shipment.statuses.sendEtgbBillDocument;
export const selectShipmentETGBBillDocumentError = (state) =>
    state.shipment.errors.sendEtgbBillDocument;

export const selectShipmentSendingToAkadStatus = (state) =>
    state.shipment.statuses.sendingToAkad;
export const selectShipmentSendingToAkadError = (state) =>
    state.shipment.errors.sendingToAkad;

export const selectShipmentSettingInvoiceTypeStatus = (state) =>
    state.shipment.statuses.settingInvoiceType;
export const selectShipmentSettingInvoiceTypeError = (state) =>
    state.shipment.errors.settingInvoiceType;

export const selectShipmentOwnInvoiceStatus = (state) =>
    state.shipment.statuses.sendOwnInvoice;
export const selectShipmentOwnInvoiceError = (state) =>
    state.shipment.errors.sendOwnInvoice;

export const selectShipmentC2CFileUploadStatus = (state) =>
    state.shipment.statuses.sendC2CFile;
export const selectShipmentC2CFileUploadError = (state) =>
    state.shipment.errors.sendC2CFile;

export const {
    setShipmentToInitialState,
    removeAllShipmentErrors,
    setIsEditingMode,
    setCollectingData,
    setAccordions,
    setUnauthorized,
    setDeletingStatus,
    setShipmentUpdatingError,
    setShipmnetDeletingError,
    setDeliveryPriceHasChanged,
    openShipmentDeletingPopup,
    closeShipmentDeletingPopup,
    setSendingToAkadStatus,
    setSendingToAkadError,
    openSendShipmentToAkadPopup,
    closeSendShipmentToAkadPopup,
} = shipmentSlice.actions;

export default shipmentSlice.reducer;
